let data = {
  //  顶部title , '写作工具', 'AI问答' '会员中心', '使用教程'
  // topTitle: ['首页','AI写小说','AI写短剧', '小说拆书', 'AI问答', '官方动态','联系我们','导师辅导'],
  topTitle: [
    "首页",
    "AI写小说",
    "AI写短剧",
    "小说拆书",
    "热门题材推荐",
    "导师辅导",
    "AI问答",
    "官方动态",
    "联系我们",
  ],
  // topTitle: ['AI写小说', '消息动态','小说拆书'],
  // 登录头像 vip类型
  headImg: [
    require("../assets/image/head.png"),
    require("../assets/image/head1.png"),
    require("../assets/image/icon_vip.png"),
    require("../assets/image/head/year.png"),
    require("../assets/image/head/month.png"),
    require("../assets/image/head/perpetual.png"),
    require("../assets/image/head/cmember.png"),
  ],
  //用户vip新图标2025-9-26替换
  userVipImg: [
    require("../assets/image/vip/common.png"),
    require("../assets/image/vip/cmember.png"),
    require("../assets/image/vip/month.png"),
    require("../assets/image/vip/three_months.png"),
    require("../assets/image/vip/half_year.png"),
    require("../assets/image/vip/year.png"),
    require("../assets/image/vip/perpetual.png"),
  ],
  //用户信息VIP
  userImg: [
    require("../assets/image/icon_userInfo1.png"),
    require("../assets/image/icon_userInfo2.png"),
    require("../assets/image/icon_userInfo9.png"),
    require("../assets/image/icon_userInfo10.png"),
    require("../assets/image/icon_userInfo11.png"),
  ],
  //用户信息退出等
  userData: [
    {
      name: "购买记录",
      icon: require("../assets/image/icon_userInfo3.png"),
      asname: "gmjl",
    },
    {
      name: "封面记录",
      icon: require("../assets/image/icon_userInfo5.png"),
      asname: "fmjl",
    },
    {
      name: "用户协议",
      icon: require("../assets/image/icon_userInfo6.png"),
      asname: "yhxy",
    },
    {
      name: "隐私政策",
      icon: require("../assets/image/icon_userInfo7.png"),
      asname: "yszc",
    },
    {
      name: "作品回收站",
      icon: require("../assets/image/recycle.png"),
      asname: "hsz",
    },
    {
      name: "邀请码",
      icon: require("../assets/image/home/invatecode.png"),
      asname: "yqm",
    },
     {
      name: "题材收藏",
      icon: require("../assets/image/home/tcsc.png"),
      asname: "tcsc",
    },
    {
      name: "退出登录",
      icon: require("../assets/image/icon_userInfo8.png"),
      asname: "tcdl",
    },
  ],
  //收藏图标
  collectIcon: [
    require("../assets/image/ai_tools/sc.png"),
    require("../assets/image/ai_tools/unsc.png"),
  ],
  //左侧title
  leftTitle: [
    {
      title: "首页",
      icon: require("../assets/image/home/home.png"),
      uIcon: require("../assets/image/home/unhome.png"),
    },
    {
      title: "AI写小说",
      icon: require("../assets/image/home/aixs.png"),
      uIcon: require("../assets/image/home/unaixs.png"),
    },
    {
      title: "AI写短剧",
      icon: require("../assets/image/home/ai_dj.png"),
      uIcon: require("../assets/image/home/ai_udj.png"),
    },
    {
      title: "小说拆书",
      icon: require("../assets/image/home/aics.png"),
      uIcon: require("../assets/image/home/unaics.png"),
    },
    {
      title: "热门题材推荐",
      icon: require("../assets/image/home/rmtctj.png"),
      uIcon: require("../assets/image/home/unrmtctj.png"),
    },
    {
      title: "导师辅导",
      icon: require("../assets/image/home/dsfd.png"),
      uIcon: require("../assets/image/home/undsfd.png"),
    },
    {
      title: "AI问答",
      icon: require("../assets/image/home/aiwd.png"),
      uIcon: require("../assets/image/home/unaiwd.png"),
    },
    {
      title: "官方动态",
      icon: require("../assets/image/home/gfxs.png"),
      uIcon: require("../assets/image/home/ungfxs.png"),
    },
    {
      title: "联系我们",
      icon: require("../assets/image/home/lxwm.png"),
      uIcon: require("../assets/image/home/ulxwm.png"),
    },
    // {
    //   title: "会员中心",
    //   icon: require('../assets/image/left_icon9.png'),
    //   uIcon: require('../assets/image/left_icon3.png'),
    // }
    // {
    //   title: "小说拆书",
    //   icon: require('../assets/image/left_icon/aparts.png'),
    //   uIcon: require('../assets/image/left_icon/apart.png'),
    // },
  ],
  // 选择图标
  iconSelect: [
    require("../assets/image/icon_select.png"),
    require("../assets/image/icon_select1.png"),
    require("../assets/image/icon_select2.png"),
    require("../assets/image/icon_create.png"),
    require("../assets/image/icon_create3.png"),
    require("../assets/image/icon_create4.png"),
    require("../assets/image/icon_create5.png"),
    require("../assets/image/icon_create6.png"),
    require("../assets/image/icon_create8.png"),
  ],
  // 性别
  sex: [
    {
      name: "男频",
      value: "男频",
      select: true,
    },
    {
      name: "女频",
      value: "女频",
      select: false,
    },
    {
      name: "无性别偏向",
      value: "无性别偏向",
      select: false,
    },
  ],
  // 性别
  scriptSex: [
    {
      name: "男频",
      value: "男",
      select: false,
    },
    {
      name: "女频",
      value: "女",
      select: false,
    },
  ],
  //ai写小说列表
  novelListIcon: [
    {
      name: "置顶",
      icon: require("../assets/image/ai_tools/zd.png"),
      uIcon: require("../assets/image/ai_tools/unzd.png"),
    },
    {
      name: "管理",
      // title:'管理',
      icon: require("../assets/image/ai_tools/gl.png"),
      uIcon: require("../assets/image/ai_tools/ungl.png"),
    },
    {
      name: "编辑",
      // title:'编辑',
      icon: require("../assets/image/ai_tools/edit.png"),
      uIcon: require("../assets/image/ai_tools/unedit.png"),
    },
    {
      name: "信息",
      icon: require("../assets/image/ai_tools/ck.png"),
      uIcon: require("../assets/image/ai_tools/unck.png"),
    },
    {
      name: "下载",
      icon: require("../assets/image/ai_tools/xz.png"),
      uIcon: require("../assets/image/ai_tools/unxz.png"),
    },
    {
      name: "克隆",
      icon: require("../assets/image/ai_tools/kl.png"),
      uIcon: require("../assets/image/ai_tools/unkl.png"),
    },
    {
      name: "删除",
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //小说写剧本列表
  scriptListIcon: [
    {
      name: "管理",
      // title:'章节管理',
      icon: require("../assets/image/ai_tools/gl.png"),
      uIcon: require("../assets/image/ai_tools/ungl.png"),
    },
    {
      name: "编辑",
      // title:'大纲编辑',
      icon: require("../assets/image/ai_tools/edit.png"),
      uIcon: require("../assets/image/ai_tools/unedit.png"),
    },
    {
      name: "信息",
      // title:'作品信息',
      icon: require("../assets/image/ai_tools/ck.png"),
      uIcon: require("../assets/image/ai_tools/unck.png"),
    },
    {
      name: "下载",
      // title:'作品下载',
      icon: require("../assets/image/ai_tools/xz.png"),
      uIcon: require("../assets/image/ai_tools/unxz.png"),
    },
    {
      name: "克隆",
      // title:'作品克隆',
      icon: require("../assets/image/ai_tools/kl.png"),
      uIcon: require("../assets/image/ai_tools/unkl.png"),
    },
    {
      name: "删除",
      // title:'作品删除',
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //小说拆书列表
  apartListIcon: [
    {
      name: "拆书管理",
      // title:'拆书管理',
      icon: require("../assets/image/ai_tools/gl.png"),
      uIcon: require("../assets/image/ai_tools/ungl.png"),
    },
    {
      name: "作品删除",
      // title:'作品删除',
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //小说拆书列表
  novelTurnListIcon: [
    {
      name: "章节管理",
      // title:'拆书管理',
      icon: require("../assets/image/ai_tools/gl.png"),
      uIcon: require("../assets/image/ai_tools/ungl.png"),
    },
    {
      name: "作品删除",
      // title:'作品删除',
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //小说回收站列表
  scriptListIcon1: [
    {
      name: "作品恢复",
      icon: require("../assets/image/huifu.png"),
      uIcon: require("../assets/image/unhuifu.png"),
    },
  ],
  //灵感记录列表
  hotHistoryList: [
    {
      name: "置顶",
      icon: require("../assets/image/ai_tools/zd.png"),
      uIcon: require("../assets/image/ai_tools/unzd.png"),
    },
    {
      name: "详情",
      icon: require("../assets/image/ai_tools/ck.png"),
      uIcon: require("../assets/image/ai_tools/unck.png"),
    },
    {
      name: "删除",
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //热门题材收藏列表
  collectList: [
    // {
    //   name: "置顶",
    //   icon: require("../assets/image/ai_tools/zd.png"),
    //   uIcon: require("../assets/image/ai_tools/unzd.png"),
    // },
    {
      name: "详情",
      icon: require("../assets/image/ai_tools/ck.png"),
      uIcon: require("../assets/image/ai_tools/unck.png"),
    },
    {
      name: "删除",
      icon: require("../assets/image/ai_tools/del.png"),
      uIcon: require("../assets/image/ai_tools/undel.png"),
    },
  ],
  //编辑页面 右侧图标
  editorRight: [
    {
      name: "信息",
      icon: require("../assets/image/icon_editor2.png"),
      uicon: require("../assets/image/ai_outline/right_1.png"),
    },
    {
      name: "大纲",
      icon: require("../assets/image/icon_editor4.png"),
      uicon: require("../assets/image/ai_outline/right_2.png"),
    },
  ],
  //大纲模板提示词
  outlineTip: [
    {
      title: "第一章：重生归来",
      content:
        "陈华意外重生，回到大学时期。初醒时，震惊与怀疑交 织，梳理现状后，回忆前世，决定制定计划。",
    },
    {
      title: "第二章：偶遇白月光",
      content:
        "制定计划后，第二天在教室，陈华撞翻了桌上一叠书， 正准备道歉，却对上一双熟悉而惊艳的眼眸—是她！前 世错过的白月光",
    },
  ],
  outlineTip1: [
    {
      title: "第一集：重生归来",
      content:
        "陈华意外重生，回到大学时期。初醒时，震惊与怀疑交 织，梳理现状后，回忆前世，决定制定计划。",
    },
    {
      title: "第二集：偶遇白月光",
      content:
        "制定计划后，第二天在教室，陈华撞翻了桌上一叠书， 正准备道歉，却对上一双熟悉而惊艳的眼眸—是她！前 世错过的白月光",
    },
  ],
  seriesTip: [
    {
      title: "第一卷：邂逅之缘",
      content:
        "沈悦在孤儿院长大，为生计在街头卖手工饰品。顾云舒的车不小心刮到沈悦的摊位，饰品散落一地。沈悦倔强地不让顾云舒赔偿",
    },
    {
      title: "第二卷：爱意萌芽",
      content:
        "沈悦和顾云舒一起去海边度假。沈悦病情发作，情绪低落，拒绝与顾云舒交流。顾云舒耐心陪伴",
    },
  ],
  ktTip: [
    {
      title:
        "为满足日益增长的用户多样化需求，全民作家金牌导师特开设多类辅导集训",
    },
    {
      title: "因导师精力有限，集训仅对外招收少量符合报名条件的用户",
    },
    {
      title: "报名前请务必仔细阅读报名要求，感谢您的理解",
    },
  ],
  //生成后分享等按钮
  iconResult: [
    {
      name: "保存",
      icon: require("@/assets/image/ai_tools/save.png"),
    },
    {
      name: "复制",
      icon: require("@/assets/image/ai_tools/copy.png"),
    },
  ],
  //提示弹框内容
  delPrompt: [
    {
      text: "是否确定删除？删除后将无法恢复，请谨慎删除！",
      icon: require("../assets/image/icon_tip2.png"),
      color: "#FF1B1B",
    },
    {
      text: "修改大纲后可能会出现与上文内容不符 请确认是否修改大纲?",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "是否退出登录？",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "退出将丢失所编辑的内容，确认退出吗？",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "未点击保存，退出将会丢失本次生成的内容，确认退出吗?",
      icon: require("../assets/image/icon_tip2.png"),
      color: "#FF1B1B",
    },
    {
      text: "修改大纲后可能会出现与上文内容不符请确认是否修改大纲?",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "若大篇幅修改正文请同步修改大纲和章纲，以避免影响后续故事情节的发展。",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "若大篇幅修改章纲请同步修改大纲，以避免影响后续故事情节的发展。",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF8802",
    },
    {
      text: "退出将会丢失长文本输入的内容，确认 退出吗?",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF1B1B",
    },
    {
      text: "当前作品确认删除?",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF1B1B",
    },
    {
      text: "当前篇章正在进行拆书，拆书结束后可进行其他操作！",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF1B1B",
    },
    {
      text: "当前进行AI生成，确认退出？",
      icon: require("../assets/image/icon_tip3.png"),
      color: "#FF1B1B",
    },
  ],
  //空状态页面信息
  noData: [
    {
      img: require("../assets/image/no_data.png"),
      content: "暂无内容",
    },
    {
      img: require("../assets/image/no_data1.png"),
      content: "你还没有创建作品",
      btn: "创建作品",
    },
    {
      img: require("../assets/image/no_data2.png"),
      content: "你还没有购买会员记录",
      btn: "购买会员",
    },
    {
      img: require("../assets/image/no_data3.png"),
      content: "你还没有下载记录",
    },
    {
      img: require("../assets/image/no_data4.png"),
      content: "你还没有封面记录",
    },
  ],
  //vip弹框
  vipTip: [
    "开通会员后不支持退款，请试用满意后再购买。",
    "若开通会员后10分钟内会员仍然没有到账，请跳转会员中心界面刷新会员或联系客服。",
    "会员时长一个月是30天，会员到期后不会自动续费。",
    "如有其他疑问，请联系客服。",
  ],
  //支付方式
  pay: [
    {
      name: "支付宝支付",
      type: "zfb",
      icon: require("../assets/image/vip_bg6.png"),
      uicon: require("../assets/image/vip_bg5.png"),
      img: require("../assets/image/vip/zfb.png"),
      w: "23px",
      h: "23px",
    },
    {
      name: "微信支付",
      type: "wx",
      icon: require("../assets/image/vip_bg8.png"),
      uicon: require("../assets/image/vip_bg7.png"),
      img: require("../assets/image/vip/wx.png"),
      w: "28px",
      h: "23px",
    },
  ],
  ewm: "Ci5pbXBvd2VyQm94IC50aXRsZSB7CiAgICBkaXNwbGF5OiBub25lOwp9Ci5pbXBvd2VyQm94IC5xcmNvZGUgewogICAgd2lkdGg6IDE2MHB4Owp9Ci5pbXBvd2VyQm94IC5pbmZvIHsKICAgIGRpc3BsYXk6IG5vbmU7Cn0=",

  //临时
  styleList: [
    "古典雅致",
    "现代简约",
    "悬疑惊悚",
    "浪漫唯美",
    "科幻奇幻",
    "幽默诙谐",
    "写实主义",
    "科幻魔幻",
    "心里探索",
  ],

  downloadHistory: [
    {
      name: "重生之和大家回到大明",
      time: "2024-5-20 17:20",
    },
    {
      name: "重生之和大家回到大明",
      time: "2024-5-20 17:20",
    },
    {
      name: "重生之和大家回到大明",
      time: "2024-5-20 17:20",
    },
    {
      name: "重生之和大家回到大明",
      time: "2024-5-20 17:20",
    },
  ],
};

export default data;
